<template>
  <v-card :elevation="24" class="px-2 py-2">
    <VersionInfoAppItem />
    <v-divider />
    <template v-for="(api, index) in apiArray" :key="api.name">
      <VersionInfoApiItem :api="api" />
      <v-divider v-if="index !== apiArray.length - 1" />
    </template>
  </v-card>
</template>

<script setup lang="ts">
  import { useVersionStore } from '@/store/versionStore';
  import VersionInfoApiItem from '@/components/VersionInfoApiItem.vue';
  import VersionInfoAppItem from '@/components/VersionInfoAppItem.vue';
  import { onMounted, onUnmounted } from 'vue';

  import { GoogleAnalytics } from '@/services/analytics/googleAnalytics';

  const versionStore = useVersionStore();

  // Access the apiVersions array from the store.
  const apiArray = versionStore.apiVersions;

  onMounted(() => {
    GoogleAnalytics.versionOpen();
  });

  onUnmounted(() => {
    GoogleAnalytics.versionClose();
  });
</script>
